"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CashBackDefault = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CashBackIcon = require("./components/CashBackIcon");
var _AvatarIcon = _interopRequireDefault(require("../AvatarIcon"));
var _styles = require("./styles");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CashBackDefault = exports.CashBackDefault = function CashBackDefault(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'm' : _ref$size,
    label = _ref.label,
    count = _ref.count,
    avatarPath = _ref.avatarPath,
    className = _ref.className,
    cashbackIconWebp = _ref.cashbackIconWebp,
    cashbackIconPng = _ref.cashbackIconPng,
    labelColor = _ref.labelColor,
    textColor = _ref.textColor,
    _ref$hasCashbackLabel = _ref.hasCashbackLabel,
    hasCashbackLabel = _ref$hasCashbackLabel === void 0 ? true : _ref$hasCashbackLabel;
  var Icon = (0, _react.useMemo)(function () {
    if (cashbackIconWebp && cashbackIconPng) {
      var CustomIcon = function CustomIcon() {
        return /*#__PURE__*/_react["default"].createElement(_CashBackIcon.CashBackCustomIcon, {
          size: size,
          cashbackIconWebp: cashbackIconWebp,
          cashbackIconPng: cashbackIconPng
        });
      };
      CustomIcon.displayName = 'CustomIcon';
      return CustomIcon;
    }
    return _CashBackIcon.CashBackIcon;
  }, [cashbackIconWebp, cashbackIconPng]);
  var labelText = label || 'Кешбэк';
  var borderStyle = className !== null && className !== void 0 && className.includes('withBorder') ? '1px solid' : 'none';
  var bgColor = labelColor || "#ffffff";
  var cashbackTextColor = textColor || "#5d6fb4";
  var clientAccountStyles = className !== null && className !== void 0 && className.includes('clientAccount') ? {
    fontSize: '16px',
    margin: '12px auto 4px',
    background: 'transparent'
  } : {};
  var columnLayoutStyles = className !== null && className !== void 0 && className.includes('column') && labelText !== 'Кешбэк' ? {
    display: 'block',
    padding: '3px 5px 2px 8px',
    lineHeight: '12px',
    borderRadius: '12px 8px'
  } : {};
  var absoluteLayoutStyles = className !== null && className !== void 0 && className.includes('hotelMobile') ? {
    position: 'absolute',
    zIndex: 2,
    left: '4px',
    top: '4px'
  } : {};
  return /*#__PURE__*/_react["default"].createElement(_styles.CashBackContainer, {
    size: size,
    labelColor: bgColor,
    textColor: cashbackTextColor,
    "data-testid": "TEST_ID_CASHBACK",
    style: _objectSpread(_objectSpread(_objectSpread({
      border: borderStyle
    }, columnLayoutStyles), clientAccountStyles), absoluteLayoutStyles)
  }, hasCashbackLabel && /*#__PURE__*/_react["default"].createElement(_styles.CashBackLabel, null, labelText), /*#__PURE__*/_react["default"].createElement(_styles.FlexContainer, null, /*#__PURE__*/_react["default"].createElement(_styles.CashBackAmount, null, count), /*#__PURE__*/_react["default"].createElement(_styles.CashBackIconLayout, null, /*#__PURE__*/_react["default"].createElement(Icon, null))), avatarPath && /*#__PURE__*/_react["default"].createElement(StyledAvatar, {
    avatarUrl: avatarPath,
    size: 20
  }));
};
var StyledAvatar = (0, _styledComponents["default"])(_AvatarIcon["default"]).withConfig({
  displayName: "CashBackDefault__StyledAvatar",
  componentId: "sc-bo9ri9-0"
})(["margin:4px 4px 4px 6px;"]);